import { contactDetailsBody } from './touchpoints';
import type { NavigationGuard } from '../state/navigationGuard';

export function contactDetailsSnapshot(value: Record<string,unknown>): string {
  const canonical=(item:unknown):unknown=>Array.isArray(item) ? item.map(canonical) : item && typeof item==='object' ? Object.fromEntries(Object.entries(item).sort(([a],[b])=>a.localeCompare(b)).map(([key,v])=>[key,canonical(v)])) : item;
  return JSON.stringify(canonical(contactDetailsBody(value)));
}

export function createContactDetailsGuard(read:()=>{editing:boolean;draft:Record<string,unknown>;baseline:string}, confirm:(message:string,signal?:AbortSignal)=>Promise<boolean>, discard:()=>void):NavigationGuard {
  let pending:AbortController|undefined;
  return {
    isDirty(){const state=read();return state.editing && contactDetailsSnapshot(state.draft)!==state.baseline;},
    confirmDiscard(){pending?.abort();pending=new AbortController();return confirm('Discard unsaved contact details?',pending.signal);},
    cancelConfirmation(){pending?.abort();pending=undefined;},
    discardAndClose(){pending?.abort();pending=undefined;discard();}
  };
}
